import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d86674f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["tabindex"]
const _hoisted_2 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "custom-select",
    tabindex: $props.tabindex,
    onBlur: _cache[1] || (_cache[1] = $event => ($data.open = false)),
    style: _normalizeStyle(`height: ${$props.height}; line-height: ${$props.height}; width: ${$props.width}`)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["selected", { open: $data.open }]),
      onClick: _cache[0] || (_cache[0] = $event => ($data.open = !$data.open))
    }, _toDisplayString(!$data.selected.name ? '選擇縣市' : $data.selected.name), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["items", { selectHide: !$data.open }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option, i) => {
        return (_openBlock(), _createElementBlock("div", {
          key: i,
          onClick: $event => {
          $data.selected = option;
          $data.open = false;
          _ctx.$emit('input', option);
        }
        }, _toDisplayString(option.name), 9, _hoisted_2))
      }), 128))
    ], 2)
  ], 44, _hoisted_1))
}